import { Component, OnInit, HostBinding, ViewEncapsulation, input } from '@angular/core';

@Component({
    selector: 'lay-panel-footer',
    templateUrl: './panel-footer.component.html',
    styleUrls: ['./panel-footer.component.sass'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PanelFooterComponent implements OnInit {

  readonly styleClass = input('');

  @HostBinding('class') get getClasses() {
    return this.styleClass();
  }

  constructor() { }

  ngOnInit() {
  }

}

/**
 * Used in Settings Lux
 */
